import React from 'react';
import './commonbluecards.scss';
import { NavLink } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
const CommonBlueCards = ({ CardData, Title,para}) => {


    return (
        <section className='cards-main'>
            <div className='common-heading'>
                <h2>{Title}</h2>
            </div>
            <div className='common-para'>
                <p className=''>{para}</p>
            </div>
            <Row className=''>
                {CardData?.map((data , index) => (
                    <Col 
                        key={index}
                        sm={12}
                        md={6}
                        lg={6}
                        xl={6}
                    >
                        <div className='common-blue-wrapper'>
                            {/* Content Section */}
                            <div className='Content'>
                                <div className='Heading'>
                                    <h3>{data.title}</h3>
                                </div>
                                <div className='Text'>
                                    <p>{data.description}</p>
                                </div>
                                <a className='link' href={data.linkUrl}>
                                    <span>{data.linkText}</span>
                                </a>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </section>
    );
};

export default CommonBlueCards;
